export default "__VITE_ASSET__BrRTX3Vu__"